import MultiEditTableCheckbox from './MultiEditTableCheckbox';

export default MultiEditTableCheckbox;
